import { computed, shallowRef, unref, watch, watchEffect, type Ref } from "vue";

import { debounce } from "@/lib/timing";
import { untrack } from "@/lib/reactivity";

export const debouncedRef = <T>(
  source: Ref<T>,
  delay = 500,
  options: { enabled?: Ref<boolean> }
): Readonly<Ref<T>> => {
  const downstream = shallowRef(unref(source));

  const isEnabled = computed((): boolean => {
    return unref(options.enabled) ?? true;
  });

  watchEffect(() => {
    if (!isEnabled.value) {
      return;
    }

    downstream.value = untrack(source);

    watch(
      source,
      debounce((value) => {
        downstream.value = value;
      }, delay)
    );
  });

  return downstream;
};
